import React from 'react';
import PopupSendToRivhit from '../PopupSendToRivhit';
import PopupEditRow from '../PopupEditRow/PopupEditRow';
import can from '../../../_common/components/Permissions/can';
import * as actions from '../../_redux/invoiceOrdersActions';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Button} from 'react-bootstrap';
import {getWhatsAppLink} from '../../../_common/utils/format';

export function MobileActionsColumnFormatter(cellContent, intl, dispatch) {
  const wasCreatedTooltip = intl.formatMessage({
    id: "invoice-orders-button-tooltip-wasCreated",
    defaultMessage: "Update that an invoice was created manually for this order",
  });
  const buttonClassName = `btn btn-icon btn-light btn-sm custom-action-button
                           ${(can('full', 'invoiceOrders'))
    ? ``
    : `custom-disabled-button cursor-default`}`;

  const message = [
    'שלום, הודעה לגבי חשבונית מוזמנת עבור',
    cellContent.customerName
  ].filter(Boolean).join(' ');
  const linkToWhatsapp = getWhatsAppLink(cellContent.phone, encodeURI(message))

  const title = intl.formatMessage({
    id: "invoice-orders-column-whatsappLink-title",
    defaultMessage: "WhatsApp link",
  });

  return (
    <div className={'d-flex flex-column align-items-center justify-content-between'}>
      <PopupEditRow
        viewMode={true}
        canCreate={cellContent.canCreate}
        status={cellContent.status}
        invoiceOrderID={cellContent._id}
      />
      <div className={'my-1'}/>
      <PopupEditRow
        canCreate={cellContent.canCreate}
        status={cellContent.status}
        invoiceOrderID={cellContent._id}
      />
      <div className={'my-1'}/>
      <Button
        className={buttonClassName}
        onClick={() => {
          dispatch(actions.setInvoiceOrderSentManually(
              cellContent?._id,
              cellContent?.totalAmount,
              cellContent?.createdAt,
              cellContent?.agentID
            )
          );
        }}
        title={wasCreatedTooltip}
        disabled={!(can('full', 'invoiceOrders'))}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Check_brandColor.svg')}
          alt="check"
        />
      </Button>
      <div className={'my-1'}/>
      <a
        href={linkToWhatsapp}
        className={'whatsappColumnButton btn btn-sm'}
        title={title}
        target={'_blank'}
        rel="noreferrer"
      >
        <img
          src={toAbsoluteUrl('/media/svg/Whatsapp_white.svg')}
          alt="whatsapp"
        />
      </a>
    </div>
  );
}
